import { isEmpty } from 'rambda';
import { type LoaderFunctionArgs, redirect } from 'react-router';
import { collectionListQueryOptions } from '@/hooks/collections/use-collections';
import ROUTES from '@/routes';
import { queryClient } from '@/utils/query-client';

export const collectionByIdLoader =
  (redirectTo?: string) =>
  async ({ params }: LoaderFunctionArgs) => {
    const { collectionId } = ROUTES.MY.COLLECTIONS.BY_ID.$deserializeParams(params);

    const collections = await queryClient.ensureQueryData(collectionListQueryOptions);

    if (isEmpty(collections)) return redirect(ROUTES.MY.COLLECTIONS.$path());

    if (collections.findIndex((c) => c.ID === collectionId) === -1)
      return redirect(redirectTo ?? ROUTES.MY.COLLECTIONS.$path());

    return {};
  };
